import { ItfEcoCartCouponItem } from './comps/EcoCartCoupon/type';

// 购物车事件
export enum ENUM_ECO_CART_EVENT {
    ECO_CART_OPEN = 'ECO_CART_OPEN',
    ECO_CART_QUERY = 'ECO_CART_QUERY',
    ECO_CART_MERGE = 'ECO_CART_MERGE',
    ECO_CART_ADD = 'ECO_CART_ADD',
    ECO_CART_INCREASE = 'ECO_CART_INCREASE',
    ECO_CART_DECREASE = 'ECO_CART_DECREASE',
    ECO_CART_REMOVE = 'ECO_CART_REMOVE',
    ECO_CART_COUPON = 'ECO_CART_COUPON',
    ECO_CART_ISLOGIN = 'ECO_CART_ISLOGIN',
    ECO_CART_ICON = 'ECO_CART_ICON',
}

export type ItfEcoCartInventoryPolicy = 'deny' | 'continue';
export interface ItfEcoCartItem {
    productId: string; // 产品id
    variantId: string; // 变体id
    inventoryPolicy: ItfEcoCartInventoryPolicy; // 库存策略
    inventoryQuantity: number; // 库存数量
    price: number; // 折扣价
    compareAtPrice: number; // 原价
    productTitle: string; // SPU标题
    skuTitle: string; // SKU标题
    img: string; // SPU图
    variantImg: string; // SKU图
    quantity: number; // 加购数量
}

export interface ItfEcoCartCss {
    ai: number;
    footer: number;
}

export type ItfEcoCartIsLogin = -1 | 0 | 1;

export interface ItfEcoCart {
    open: boolean;
    items: ItfEcoCartItem[];
    isLogin: ItfEcoCartIsLogin;
    coupon: ItfEcoCartCouponItem | null;
    icon: string;
}

export interface ItfEcoCartItemChange {
    compareAtPrice: number;
    price: number;
    productId: number; // 后端定义为number，这里应该是string才符合规范
    variantId: number; // 后端定义为number，这里应该是string才符合规范
    properties?: any;
    quantity: number;
}

export interface ItfEcoCartItemInit {
    productId: string; // 产品id
    variantId: string; // 变体id
    inventoryPolicy: ItfEcoCartInventoryPolicy; // 库存策略
    inventoryQuantity: number; // 库存数量
    price: string; // 折扣价 后端返回的string类型
    compareAtPrice: string; // 原价 后端返回的string类型
    productTitle: string; // SPU标题
    skuTitle: string; // SKU标题
    img: string; // SPU图
    variantImg: string; // SKU图
    quantity: number; // 加购数量
    userQuantity?: number; // API_GET_USER_CART 接口会返回这个字段
    properties?: any; // 后端返回的 - 内容未知
}
